import React, { useContext } from 'react';
import { BaseContext } from '../contexts/baseContext';

// const img = require("../../docs/fondGris.png");
import img from '../../docs/fondGris.png';
import photo from '../../docs/renard3.png';

export default function Welcome() {
  const { windowHeight, currentUser } = useContext(BaseContext);

  return (
    <section className={`col-sm section-welcome`} style={{ height: `${windowHeight}px` }}>
      <div className="container-welcome">
        <div className="logo-welcome">
          <img src={ img } alt="logo du site" data-src={ photo }/>
        </div>
        <span className="welcome-message">
          Hey, { currentUser.nom }
        </span>
        <span className="welcome-indication">
          Select a discussion and start talking
        </span>
      </div>
    </section>
  );
}
